import { useEffect } from 'react';
import { PhoneOff } from 'lucide-react';
import { Button, EmptyState } from '@cyphex/ui';
import { closeDesktopCallWindow } from '../callWindow';

/**
 * WHAT A CALL WINDOW SHOWS INSTEAD OF THE SIGN-IN PAGE.
 *
 * A call window whose token goes away used to fall through `RequireAuth` to
 * `/login`, and a sign-in form in that window is a hazard, not a dead end:
 * every window in this shell shares ONE cookie jar, so `POST /auth/login` there
 * writes a fresh `cxt_rt` over the workspace's — with a DIFFERENT account if a
 * different one is used — and the workspace's next rotation quietly continues
 * as somebody else. `/auth/logout` destroys the same cookie for both.
 *
 * The shell refuses those requests outright (`installAuthGuard`), so the form
 * could only ever fail here; showing it at all would be offering the user a
 * control that cannot work. The window closes instead, and signing in again is
 * what the workspace window is for.
 *
 * The message is on screen for the moment before the shell destroys the window,
 * and it is what stays if the close IPC cannot be delivered at all.
 */
export function CallWindowSignedOut() {
  useEffect(() => {
    closeDesktopCallWindow('');
  }, []);

  return (
    <main className="flex h-full items-center justify-center bg-background p-8">
      <EmptyState
        icon={PhoneOff}
        title="Your session ended"
        description="Sign in again in the main Cyphex Teams window."
        action={
          <Button variant="primary" onClick={() => closeDesktopCallWindow('')}>
            Close
          </Button>
        }
      />
    </main>
  );
}
